<div class="page">
  <div class="subheader">
    <i class="subicon icon-angle-double-left" (click)="order.closeSidebar()"></i>
    <i class="usericon icon-group-o icon"></i
    ><span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.CustomerHeaderTitle" | translate }}</span>
  </div>
  <div class="customersname">
    <ssg-tabset class="subtitle">
      <ssg-tab class="tabular" [tabTitle]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.TabTitleHeader' | translate">
        <div class="infobox" *ngIf="_isCreateFormGroup" (click)="StayOnFastAccessPage()">
          <ssg-input
            name="inputName"
            [group]="group"
            (input)="FilterName()"
            class="info"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.InputName' | translate"></ssg-input>
          <ssg-input
            name="inputNumber"
            [group]="group"
            (input)="FilterName()"
            class="info"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.InputNumber' | translate"></ssg-input>
          <ssg-input
            name="inputPhone"
            [group]="group"
            (input)="FilterName()"
            class="info"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.InputPhone' | translate"
            textType="number"></ssg-input>
          <ssg-input
            name="inputAddress"
            [group]="group"
            (input)="FilterName()"
            class="info"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.InputAddress' | translate"></ssg-input>
        </div>

        <div class="customercontent">
          <div *ngFor="let customer of _customers" class="subinfocall customerlist">
            <div class="contentinfo" (click)="SetInvoiceCustomerName(customer.Id)">
              <div class="information">
                <div class="customerinfo">
                  <i class="icon-person_outline-o"></i><span>{{ customer.Party.DisplayName }}</span>
                </div>
                <div>
                  {{ customer.Number }}
                </div>
              </div>
              <div class="customertel">
                <i class="icon-call-o"></i> <span>{{ customer.Numbers[0]?.Number }}</span>
              </div>
            </div>
            <div class="footer">
              <div (click)="GetCustomerDetails(customer.Id)">
                <i class="icon-keyboard_arrow_down-o chevicon"></i>
                <span class="more">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.Continue" | translate }}</span>
              </div>
              <div>
                <div class="customerinfo" *ngIf="moreInfo && customer.Id === moreInfo.Id">
                  <div class="customerdetail">
                    <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.LimitCredit" | translate }}: </span>
                    <span>{{ moreInfo.CreditLimit }}</span>
                    <span *ngIf="moreInfo?.TotalBuy && moreInfo?.CreditLimit > 0">{{
                      "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.UnitPrice" | translate
                    }}</span>
                  </div>
                  <div class="customerdetail">
                    <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.TimeArrive" | translate }} : </span>
                    <span> {{ moreInfo?.MinutesToDelivery }}</span>
                    <span *ngIf="moreInfo?.MinutesToDelivery && moreInfo?.MinutesToDelivery > 0">{{
                      "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.Minutes" | translate
                    }}</span>
                  </div>
                  <div class="customerdetail">
                    <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.LastPurchase" | translate }}: </span>
                    <span>{{ moreInfo.LastBuy }}</span>
                    <span *ngIf="moreInfo?.LastBuy && moreInfo?.LastBuy > 0">{{
                      "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.UnitPrice" | translate
                    }}</span>
                  </div>
                  <div class="customerdetail">
                    <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.SumPrice" | translate }}: </span>
                    <span>{{ moreInfo.TotalBuy }}</span>
                    <span *ngIf="moreInfo?.TotalBuy && moreInfo?.TotalBuy > 0">{{
                      "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.UnitPrice" | translate
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab class="tabular calltab" [tabTitle]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.TabTitleCalling' | translate">
        <div>
          <span class="calltitle">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.CallHeaderTitle" | translate }}</span>
        </div>
        <div class="callinfo">
          <div class="subinfocall callcard" *ngFor="let ringingMissCall of _RingingMissCallList">
            <div class="callcolor"></div>
            <div class="callcontent">
              <div>{{ ringingMissCall.Number }}</div>
              <div class="line">
                <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.Line" | translate }} {{ ringingMissCall.Line }}</span>
                <i class="icon-call-o"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="listbox">
          <span class="title">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.CallBoxTitle" | translate }}</span>

          <div class="calllist">
            <div class="subinfocall listinfo" *ngFor="let toDayCall of _ToDayCallList">
              <div>
                <i class="icon-user-check listicon"></i>
                <span class="listtext">{{
                  toDayCall.CustomerName
                    ? toDayCall.CustomerName
                    : ("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.NoSubscription" | translate)
                }}</span>
              </div>
              <div>
                <i class="icon-phone_missed-F listicon"></i> <span class="listtext"> {{ toDayCall.CallStatusTitle }}</span>
              </div>
              <div class="line-number">
                <div>
                  <i class="icon-user-check listicon"></i>
                  <span class="listtext"
                    >{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.Number" | translate }}: {{ toDayCall.Number }}</span
                  >
                </div>
                <div>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.Line" | translate }}: {{ toDayCall.Line }}</div>
              </div>
            </div>
          </div>
        </div>
      </ssg-tab>
    </ssg-tabset>
  </div>
</div>
